import type { z } from 'zod';
import { availabilitySchema } from '../../../GET/employee/availability/response';

export const createAvailabilitySchema = availabilitySchema.omit({
  id: true,
  empId: true,
});

export type CreateAvailability = z.infer<typeof createAvailabilitySchema>;
